import { call, put, select, takeLatest } from 'redux-saga/effects';
import { stringify } from 'query-string';

import {
  BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS,
  FETCH_SYMPHONY_SEARCH_COMPONENTS_ERROR,
  RECEIVE_SYMPHONY_SEARCH_COMPONENTS
} from 'store/ducks/search/types';
import { classifyUpstreamResult, getSearchContentTimeoutMs, reportDegradation, withTimeout } from 'helpers/upstreamDegradation';
import { selectZcsConfig } from 'selectors/environment';
import timedFetch from 'middleware/timedFetch';
import { addClientHeaders, fetchOpts } from 'apis/mafia/common';
import { ZSO_STRING_RE } from 'common/regex';

export function getSymphonySearchComponents(
  { url },
  { term, path },
  credentials = {},
  request = {},
  fetcher = timedFetch('getSymphonySearchComponents'),
  signal
) {
  const queryObj = {
    pageName: term,
    pageLayout: 'search'
  };

  if (path) {
    if (path.includes('.zso')) {
      queryObj['ProductSearchZso'] = path;
    } else {
      queryObj['ProductSearchTerm'] = path;
    }
  }
  const query = stringify(queryObj);
  const reqUrl = `${url}/zcs/getSlots?${query}`;
  const headers = addClientHeaders(request);
  return fetcher(reqUrl, fetchOpts({ headers, signal }, credentials));
}

export function* workFetchSymphonySearchComponents() {
  try {
    const {
      client: { request },
      cookies,
      filters: { term, executedSearchUrl }
    } = yield select();
    const zcsConfig = yield select(selectZcsConfig);
    const zsoString = ZSO_STRING_RE.exec(executedSearchUrl)?.[0];
    const response = yield call(
      withTimeout,
      signal =>
        getSymphonySearchComponents(zcsConfig, { term: term || zsoString || 'null', path: executedSearchUrl }, cookies, request, undefined, signal),
      getSearchContentTimeoutMs()
    );
    const data = yield response.json();
    yield put({
      type: RECEIVE_SYMPHONY_SEARCH_COMPONENTS,
      payload: { data, term }
    });
  } catch (error) {
    yield put({
      type: FETCH_SYMPHONY_SEARCH_COMPONENTS_ERROR,
      payload: { error }
    });
    // A customer-initiated navigation cancel (AbortError) is not a degradation,
    // so the slot is cleared without emitting a failure metric.
    if (classifyUpstreamResult(error) === 'degraded') {
      yield call(reportDegradation, {
        service: 'Olympus',
        operation: 'SearchResultsLoad',
        region: 'SymphonySearchComponents',
        error
      });
    }
  }
}

export function* watchFetchSymphonySearchComponents() {
  yield takeLatest(BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS, workFetchSymphonySearchComponents);
}

export default [watchFetchSymphonySearchComponents];
